import scrollTo from 'gatsby-plugin-smoothscroll';
import {forceVisible} from 'react-lazyload';

export default function scrollToBlock(wrapper) {
    forceVisible();
    window.setTimeout(() => {
        scrollTo(wrapper);
    }, 50);
}
